import { CircleAlert } from 'lucide-react';

export function LinkFinalizadoErro() {
  return (
    <div className='content'>
        <div className='content-liveness'>
            <div className='header'>Validação</div>

            <div className='content-success'>
                <CircleAlert color='#363636' strokeWidth={2} size={150}/>
                <span>Validação não aprovada. Link finalizado.</span>
            </div>
        </div>
    </div>
  );
}